module.exports = __webpack_public_path__ + "static/img/8.b90cfd2c.jpg";